import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetchShiftSummary,
  fetchCashDrops,
  recordCashDrop,
  type ShiftSummaryQuery,
  type CashDropsQuery,
  type RecordCashDropInput,
} from '@/services/api/shift.api';

export function useShiftSummary(query: ShiftSummaryQuery, enabled = true) {
  return useQuery({
    queryKey: ['shift', 'summary', query],
    queryFn: () => fetchShiftSummary(query),
    staleTime: 30_000,
    enabled: enabled && !!query.propertyId && !!query.date,
  });
}

export function useCashDrops(query: CashDropsQuery, enabled = true) {
  return useQuery({
    queryKey: ['shift', 'cash-drops', query],
    queryFn: () => fetchCashDrops(query),
    staleTime: 30_000,
    enabled: enabled && !!query.propertyId && !!query.date,
  });
}

export function useRecordCashDrop() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: RecordCashDropInput) => recordCashDrop(input),
    onSuccess: () => {
      // A drop changes both the day's drop list and the summary's
      // cashDropped / cashInDrawer, so invalidate both.
      queryClient.invalidateQueries({ queryKey: ['shift', 'summary'] });
      queryClient.invalidateQueries({ queryKey: ['shift', 'cash-drops'] });
    },
  });
}
